module.exports = __webpack_public_path__ + "img/email.13e971cb.svg";